<template>
  <div style="padding: 0px">
    <Keypress
      :multiple-keys="multiple"
      key-event="keyup"
      @success="checkPoint"
      @wrong="otherMethod"
    />
    
    
    

    <div class="mb-0 text-center">
      <img class="logo-size" src="images/logo_muic.png" alt="imag_timescan_1" />
    </div>

    <!-- content -->

    <div class="mt-0 text-center">
      <h1 class="mt-0 mb-0">
        <a-icon class="mr-10" type="clock-circle" />{{ currentTime }}
      </h1>
    </div>

    <a-card
      style="background-image: url('images/bg-profile.jpg')"
      class="font-web mt-5"
      hoverable
    >
      <template slot="actions" class="ant-card-actions">
        <div>
          <h6 class="mt-0 mb-0" style="font-weight: 900; color: #000000">
            {{ dataSer }}
          </h6>
          <p class="mt-0 font-web mb-0 text-muted" style="font-weight: 900">
            Data recording time
          </p>
        </div>
        <h2 class="mt-5 mb-5">
          <span class="text-success" v-if="dataProfile.length !== 0">{{
            moment(dataProfile[0].created_at).locale("th").format("LTS")
          }}</span>
          <span class="text-muted" v-else>--:--:--</span>
        </h2>
      </template>
      <a-card-meta>
        <div slot="title">
          <div class="text-center text-white" v-if="loadingScan">
            <a-spin class="mr-2" /> Send data ...
          </div>
          <h4 v-else class="text-center text-white mt-0 mb-0">
            <span v-if="dataProfile.length !== 0">
              <a-alert
                :message="`${dataProfile[0].user_detail.code} :: ${dataProfile[0].user_detail.name} ${dataProfile[0].user_detail.surname}`"
                type="success"
              />
            </span>
            <span v-else>- Please scan the card -</span>
          </h4>
        </div>
        
      </a-card-meta>
    </a-card>
    <!-- content -->
  </div>
</template>

<script>
export default {
  components: {
    Keypress: () => import("vue-keypress"),
  },
  data() {
    return {
      valTemp: "Key name",
      // 022977837617809160
      valKey: "",
      multiple: [
        {
          keyCode: 13, // Enter
          modifiers: [],
          preventDefault: true,
        },
      ],
      // res api data
      loadingScan: false,
      timeStart: this.moment().format("YYYY-MM-DD"),
      timeEnd: this.moment().add(1, "days").format("YYYY-MM-DD"),
      dataLocation: [],
      dataProfile: [],
      // time zone
      currentTime: null,
      countData: 0,
      hou: 0,
      sec: 5,
      serverTime: "",
      ttt: "",
      serverNowDate: "",
      dataSer: "",
      errorMsgCallData: "",
    };
  },
  computed: {
    getUrlPath() {
      return this.$route.query.token;
    },
  },
  created() {
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  mounted() {
    this.getServerDateTime();
  },
  watch: {
    currentTime(val) {
      if (
        [
          "0:00:00",
          "0:01:00",
          "00:00:00",
          "00:01:00",
          "23:59:59",
          "24:00:00",
          "24:01:00",
          "1:00:00",
          "6:00:00",
          "15:30:00",
        ].includes(val)
      ) {
        this.getServerDateTime();
      }
    },
  },
  methods: {
    // time zone
    updateCurrentTime() {
      this.currentTime = this.moment(
        this.ttt !== "" ? this.ttt : this.currentTime,
        "HH:mm:ss"
      )
        .add(1, "seconds")
        .locale("th")
        .format("LTS");
      this.ttt = this.currentTime;
    },
    async getServerDateTime() {
      this.serverTime = "";
      this.serverNowDate = "";
      try {
        const restime = await this.$http.get(
          `/hri/time_attendance/time_server/`
        );
        if (restime.status === 200) {
          this.dataSer = this.moment(restime.data.full_time).format(
            "DD / MMMM / YYYY"
          );
          this.serverTime = this.moment(restime.data.full_time)
            .locale("th")
            .format("LTS");
          this.serverNowDate = this.moment(restime.data.full_time)
            .locale("th")
            .format("YYYY-MM-DD");
          this.currentTime = this.serverTime;
        } else {
          const error = new Error('Request Failed');
          error.restime = restime;
          error.response = restime; // Ensure compatibility if catch uses .response
          throw error;
        }
      } catch (error) {
        this.serverTime = "";
        this.handleErrorCase(
          error.response.status,
          `Caught problem api '/hri/time_attendance/time_server/' process. Pleses refresh the page and try again.`
        );
      }
    },
    // time zone
    checkDataRender(val, obj) {
      return val.length === 0 ? "-" : val[0][obj];
    },
    handleErrorCase(dataA, dataB) {
      this.$notification.open({
        style: {
          backgroundColor: "#ff1919",
          color: "#ffffff",
        },
        message: function (h) {
          return h("div", [h("strong", { class: "" }, `Error ${dataA}`)]);
        },
        description: `Problem issue connect api : ${dataB}`,
      });
    },
    // connect api
    clearDataObj() {
      this.dataProfile = [];
      this.valKey = "";
    },
    async checkPoint(response) {
      this.loadingScan = true;
      this.dataProfile = [];
      let sendId = "";
      try {
        sendId = this.valKey;
        const sendData = new FormData();
        sendData.append("card_key", sendId);
        sendData.append("location", this.getUrlPath);
        sendData.append(
          "created_at",
          `${this.serverNowDate} ${this.currentTime}`
        );
        const res = await this.$http.post(
          "/hri/time_attendance/new_sent_data/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res.status === 201) {
          this.dataProfile.push(res.data);
          this.loadingScan = false;
          // clear
          sendId = "";
          this.valKey = "";
          setTimeout(() => this.clearDataObj(), 5000);
          // clear
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        // clear
        this.valKey = "";
        this.clearDataObj();
        // clear
        this.loadingScan = false;
        this.handleErrorCase(
          error.response.status,
          `/hri/time_attendance/new_sent_data/`
        );
      }
    },
    otherMethod(response) {
      if (response.event.keyCode >= 48 && response.event.keyCode <= 57) {
        let temp = response.event.keyCode - 48;
        this.valKey += `${temp}`;
      } else if (
        response.event.keyCode >= 96 &&
        response.event.keyCode <= 105
      ) {
        let temp = response.event.keyCode - 96;
        this.valKey += `${temp}`;
      } else if (
        response.event.keyCode === 8 ||
        response.event.keyCode === 46
      ) {
        this.valKey = this.valKey.substring(0, this.valKey.length - 1);
      } else if (response.event.keyCode == 188) {
        this.valKey = this.valKey + ",";
      }
    },
  },
};
</script>

<style scoped>
.img-size-lock {
  width: 250px;
  height: 300px;
}
.logo-size {
  width: 200px;
  height: 70px;
  margin-top: 5px;
  z-index: -999;
}
.example {
  text-align: center;
  background: #60d5ff4d;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}
</style>